export default () => ({
  container: {
    width: '100vw',
    height: '100vh',
    minHeight: 667,
    padding: '52px 36px',
    backgroundImage: ({ quizBackground }) => `url(${quizBackground})`,
    backgroundRepeat: 'no-repeat',
    '@media (min-aspect-ratio: 3/5)': {
      backgroundSize: 'cover',
    },
  },
  questionNumIcon: {
    minWidth: 72,
    height: 72,
  },
  formControl: {
    backgroundColor: 'transparent',
  },
  questionContent: {
    margin: '8px 0 0 8px',
  },
  nextButton: {
    borderRadius: 32,
    width: 160,
    height: 32,
    color: '#FFFFFF',
  },
  shareButtons: {
    display: 'flex',
    justifyContent: 'center',
  },
  shareButton: {
    minWidth: 0,
    padding: 0,
    marginRight: 8,
  },

  // prize draw
  wheelContainer: {
    width: '100vw',
    height: '100%',
    position: 'relative',
    backgroundRepeat: 'no-repeat',
    minHeight: 667,
    '@media (min-aspect-ratio: 3/5) and (max-aspect-ratio: 4/5)': {
      backgroundSize: 'cover',
    },
  },
  wheel: {
    width: '100vw',
    height: '100vh',
    maxWidth: 557,
    position: 'absolute',
    top: 248,
  },
  wheelImage: {
    width: '100%',
    maxWidth: 557,
    zIndex: 1000,
    position: 'absolute',
  },
  button: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  prizeImage: props => ({
    width: '100%',
    maxWidth: 557,
    transition: `${props.duration}s`,
    'transition-timing-function': `${props.timing}`,
    transform: `rotate(${props.deg}deg) scale(0.78)`,
    position: 'absolute',
    top: 16,
  }),
  buttonImage: {
    zIndex: 1001,
    width: '100%',
    position: 'absolute',
    '&:active': {
      transform: 'scale(0.8)',
    },
  },
});
